import { uiText } from '../../../utils/uiTranslation';
import React from 'react';
import {
  formatDate,
  formatMetric,
  getResultMetric,
  getStatusTone
} from './nationalizationViewModel';

export default function NationalizationForecastCard({ overview, language, t }) {
  const forecast = overview?.forecast || {};
  const metric = getResultMetric(forecast);
  const tone = getStatusTone(forecast.status_code);
  const statusLabel = t(`status.${forecast.status_code || 'unknown'}`, forecast.status_code || 'Unknown');

  return (
    <section className="nationalization-support-card nationalization-forecast-card">
      <div className="nationalization-support-card-header">
        <div>
          <h3>{t('resultStates.forecast', 'Future forecast')}</h3>
          <p>{t('resultStates.forecastHelp', 'Includes confirmed future changes such as employees who have not started yet.')}</p>
        </div>
        <span>{t('page.forecastAsOf', 'Forecast through {{date}}', {
          date: formatDate(overview?.forecast_as_of, language)
        })}</span>
      </div>
      <div className="nationalization-forecast-result">
        <strong className={`nationalization-tone-${tone}`}>
          {formatMetric(metric.current, metric.suffix, 1, language)}
        </strong>
        <div>
          <p>{uiText(statusLabel)}</p>
          {forecast.gap_count !== null && forecast.gap_count !== undefined && (
            <small>{t('resultStates.gapCount', '{{count}} remaining', { count: forecast.gap_count })}</small>
          )}
        </div>
      </div>
    </section>
  );
}
